module.exports = __webpack_public_path__ + "img/fd_60.fc9a317f.png";